export default "__VITE_ASSET__mk930Fgk__"